import { Injectable } from "@angular/core";
import { NzMessageService } from "ng-zorro-antd/message";
import { ApiService } from "../services/api.service";
import { BehaviorSubject, Observer, Subject, Subscription } from "rxjs";
import { ProjectResponseModel } from "../models/project.model";
import { ApiServiceDelegate } from "../models/api-service-delegate";
import { ApiCollection } from "../providers/api-collection";
import { ClientResponseModel } from "../models/client.model";
import { AddProjectPlanComponent } from "../components/add-project-plan/add-project-plan.component";
import { ProjectPlansComponent } from "../pages/action-center/project-plans/project-plans.component";
import { ProjectPlanModel, ProjectPlanResponseModel, ProjectQuestionResponseModel } from "../models/project-plan.model";
import { ProjectPlanDrawerComponent } from "../components/project-plan-drawer/project-plan-drawer.component";
import { HttpEventType, HttpResponse } from "@angular/common/http";


@Injectable({
    providedIn: "root",
})

export class ProjectPlanViewModel {

    parentAddProjectPlanComponent: AddProjectPlanComponent;
    parentProjectPlansComponent: ProjectPlansComponent
    parentProjectPlanDrawerComponent: ProjectPlanDrawerComponent;

    projectListData = new BehaviorSubject<ProjectResponseModel>(new ProjectResponseModel());
    projectPlanList = new BehaviorSubject<ProjectPlanResponseModel>(new ProjectPlanResponseModel());
    projectQuestion = new BehaviorSubject<ProjectQuestionResponseModel>(new ProjectQuestionResponseModel());
    projectPlanModel = new BehaviorSubject<ProjectPlanModel>(new ProjectPlanModel());

    constructor(
        private apiService: ApiService,
        private message: NzMessageService
    ) { }

    subscribeToProjectQuestion(
        observer: Observer<ProjectQuestionResponseModel>,
    ){
        this.projectQuestion.subscribe(observer);
    }
    
    subscribeToProjectPlanModel(
        observer: Observer<ProjectPlanModel>,
    ){
        this.projectPlanModel.subscribe(observer);
    }
    
    subscribeToprojectList(
        observer: Observer<ProjectResponseModel>,
    ){
        this.projectListData.subscribe(observer);
    }

    getProjectQuestions(page: number, page_size: number, name: string = ''){
        let url = ApiCollection.Question + '?page=' + page + '&page_size=' + page_size;
        if(name.length > 0){
            url += '&name=' + name;
        }
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action:  url,
            Success: (e: any) => {
                this.projectQuestion.next(e);
                return e;
            },
            Error: (e: String) => {
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getProjectPlanList(page: number, page_size: number, name?: string){
        let url = ApiCollection.Project_Plan + '?page=' + page + '&page_size=' + page_size;
        if(name){
            url += '&name=' + name;
        }
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action:  url,
            Success: (e: any) => {
                this.projectPlanList.next(e);
                this.parentProjectPlansComponent.projectPlanReceived();
                return e;
            },
            Error: (e: String) => {
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getProjectList(name: string) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.Project + '?page=' + 1 + '&page_size=' + 10 + 
            '&name=' + encodeURIComponent(name) + "&has_project_plan=false",
            Success: (e: any) => {
                this.projectListData.next(e);
                this.parentAddProjectPlanComponent.projectDataReceived();
                return e;
            },
            Error: (e: String) => {
                return e;
            },
        };
        this.apiService.callService(d);
    }

    createProjectPlan(projectId: number, created_by: number){
        let d: ApiServiceDelegate = {
            Data: { source_project: projectId, created_by: created_by, onboarding_plan: []},
            Method: "POST",
            Action: ApiCollection.Project_Plan,
            Success: (e: any) => {
                this.parentAddProjectPlanComponent.projectPlanCreated();
                this.message.success("Project plan created successfully", { nzDuration: 1000 });
                return e;
            },
            Error: (e: String) => {
                this.message.error(String(e), { nzDuration: 1000 });
                return e;
            },
        };
        this.apiService.callService(d);
    }

    updateProjectPlan(payload: any){
        let d: ApiServiceDelegate = {
            Data: {
                id: payload.id,
                onboarding_q_plan: payload.onboarding_q_plan
            },
            Method: "PATCH",
            Action: ApiCollection.Project_Plan + '/' + payload.id,
            Success: (e: any) => {
                // this.parentProjectPlanDrawerComponent.refreshProjectPlan();
                this.message.success("Questions added successfully!", { nzDuration: 1000 });
                return e;
            },
            Error: (e: String) => {
                this.message.error(String(e), { nzDuration: 1000 });
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getProjectPlanbyID(id: number){
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.Project_Plan + '/' + id.toString(),
            Success: (e: any) => {
                this.projectPlanModel.next(e);
                this.parentProjectPlanDrawerComponent.projectPlanReceived();
                return e;
            },
            Error: (e: String) => {
                this.message.error(String(e), { nzDuration: 1000 });
                return e;
            },
        };
        this.apiService.callService(d);
    }

    updateProjectPlanAns(payload: any){
        let d: ApiServiceDelegate = {
            Data: payload,
            Method: "POST",
            Action: ApiCollection.Project_Plan_Add_Bulk,
            Success: (e: any) => {
                this.parentProjectPlanDrawerComponent.updatedProjectPlanAns();
                this.message.success("Questions added successfully!", { nzDuration: 1000 });
                return e;
            },
            Error: (e: String) => {
                this.message.error(String(e), { nzDuration: 1000 });
                return e;
            },
        };
        this.apiService.callService(d);
    }

     getMediaFile(data:any, type:any){
            let d: ApiServiceDelegate = {
                Data:data,
                Method: "GET",
                Action: ApiCollection.Media + '/' + data,
                Success: (e: any) => {
                    this.parentProjectPlanDrawerComponent.fileDownloaded(e, type)
                    // this.message.success("File deleted successfully!", {nzDuration: 1000});
                    return e;
                },
                Error: (e: String) => {
                    // this.message.success("Tasks loaded unsuccessfully", {nzDuration: 1000});
                    return e;
                },
            };
            this.apiService.callService(d);
    }

     deleteMediaFile(data, type:any,index?:any){
            let d: ApiServiceDelegate = {
                Data:data,
                Method: "DELETE",
                Action: ApiCollection.Media + '/' + data,
                Success: (e: any) => {
                    this.parentProjectPlanDrawerComponent.fileDeleted(type,index)
                    this.message.success("File deleted successfully!", {nzDuration: 1000});
                    return e;
                },
                Error: (e: String) => {
                    // this.message.success("Tasks loaded unsuccessfully", {nzDuration: 1000});
                    return e;
                },
            };
            this.apiService.callService(d);
        }

     uploadMediaFile(item: any, userId: any): Subscription {
                const formData = new FormData();
                formData.append('file', item.file as File);
                formData.append('name', item.file.name);
                formData.append('created_by', userId);
              
                return this.apiService.uploadFileWithProgress(ApiCollection.Media, formData).subscribe({
                  next: (event) => {
                    if (event.type === HttpEventType.UploadProgress) {
                      const percentDone = Math.round((100 * event.loaded) / (event.total || 1));
                      item.onProgress!({ percent: percentDone }, item.file); 
                    } else if (event instanceof HttpResponse) {
                      item.onSuccess!(event.body, item.file, event);
                    }
                  },
                  error: (error) => {
                    item.onError!(error, item.file);
                  },
                  complete: () => {
                    console.log('Upload process completed.');
                  }
                });
              }
}